import ui from './ui';
import auth from './auth';
import company from './company';
import invoice from './invoice';
import users from './users';
import client from './clients';
import invoices from './invoices';
import statistics from './statistics';
import payroll from './payroll';
import employee from './employee';
import employees from './employees';
import customers from './customers';
import messages from './messages';
import modalForm from './modal-form';

export default {
  ui,
  auth,
  company,
  invoice,
  users,
  client,
  invoices,
  statistics,
  payroll,
  employee,
  employees,
  customers,
  messages,
  modalForm,
};
